import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';
import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getCacheQueryInsightsV2;

export type DatabaseQueryInsightsQueryData = ApiResponse<typeof apiFn>;

const DBO_DATABASE_QUERY_INSIGHTS_QUERY_KEY = 'dbo-database-query-insights';

const getDatabaseQueryInsightsQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => [DBO_DATABASE_QUERY_INSIGHTS_QUERY_KEY, params] as const;

export const useDatabaseQueryInsightsQuery = <
  TSelected = DatabaseQueryInsightsQueryData
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DatabaseQueryInsightsQueryData, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getDatabaseQueryInsightsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      enabled: makeIsEnabled(
        !!params.organizationId,
        !!params.proxyId,
        !!params.databaseName,
        !!params.templateHash,
        options?.enabled ?? true
      ),
      ...options,
    })
  );
